import Axios from 'axios';
import AxiosMiddleware from '../libs/AxiosMiddleware';
import Config from '@/config';
import OPCODE from '@/libs/OPCODE';
import _ from 'lodash';

export const TYPES = {
  UPDATE_WHOLESALES: 'UPDATE_WHOLESALES',
  SWITCH_WHOLESALES: 'SWITCH_WHOLESALES',
  SWITCH_ALL_WHOLESALES: 'SWITCH_ALL_WHOLESALES',
  WHOLESALE_SEARCH: 'WHOLESALE_SEARCH',
  WHOLESALE_SORTING: 'WHOLESALE_SORTING',
  DELETE_WHOLESALE_BY_IDX: 'DELETE_WHOLESALE_BY_IDX',
  EDITING_INFO: 'EDITING_INFO'
};

export const state = {
  editingInfo: { enabled: false, idx: '', isDup: false },
  wholesales: [],
  displayed: [],
  indeterminate: false,
  selectedAll: false,
  selected: []
};

export const mutations = {
  [TYPES.DELETE_WHOLESALE_BY_IDX](state, idx) {
    _.remove(state.wholesales, v => v.idx === idx);
  },
  [TYPES.UPDATE_WHOLESALES](state, res) {
    state.wholesales = res;
    state.displayed = res;
  },
  [TYPES.SWITCH_WHOLESALES](state, idx) {
    if (state.selected.includes(idx)) {
      const index = state.selected.indexOf(idx);
      state.selected.splice(index, 1);
    } else {
      state.selected.push(idx);
    }

    if (state.wholesales.length === state.selected.length) {
      state.selectedAll = true;
      state.indeterminate = false;
    } else if (state.selected.length >= 1) {
      state.selectedAll = false;
      state.indeterminate = true;
    } else {
      state.selectedAll = false;
      state.indeterminate = false;
    }
  },
  [TYPES.SWITCH_ALL_WHOLESALES](state) {
    if (state.selectedAll || state.indeterminate) {
      state.selectedAll = false;
      state.selected = [];
    } else {
      state.selectedAll = true;
      for (const wholesale of state.displayed) {
        state.selected.push(wholesale.idx);
      }
    }
  },
  [TYPES.WHOLESALE_SEARCH](state, text) {
    if (text === undefined || text === '')
      return (state.displayed = state.wholesales);

    state.displayed = [];
    for (const wholesale of state.wholesales) {
      if (wholesale.name.includes(text)) {
        state.displayed.push(wholesale);
      }
    }
  },
  [TYPES.WHOLESALE_SORTING](state, type, reverse = false) {
    const has = item => (state.selected.includes(item.idx) ? 1 : 0);
    const loc = loc =>
      loc.building + loc.mall + loc.floor + loc.row + loc.place;

    switch (type) {
      case 'checkbox':
        state.displayed.sort((a, b) => {
          [a, b] = [has(a), has(b)];
          return a === b ? 0 : a ? -1 : 1;
        });
        break;
      case 'name':
        state.displayed.sort();
        break;
      case 'location':
        state.displayed.sort((a, b) => {
          [a, b] = [loc(a), loc(b)];
          return a.localeCompare(b);
        });
        break;
    }

    if (reverse) state.displayed.reverse();
  },
  [TYPES.EDITING_INFO](state, obj = { idx: '', isDup: false }) {
    state.editingInfo = obj;
  }
};

export const actions = {
  async refreshWholesales({ commit }) {
    const { data } = await Axios.get(`${Config.hostname}/v1/wholesale`, {
      withCredentials: true
    });

    if (AxiosMiddleware(data.opcode)) {
      switch (data.opcode) {
        case OPCODE.SUCCESS:
          commit(TYPES.UPDATE_WHOLESALES, data.wholesales);
          break;
      }
    }
  },
  editWholesale({ commit }, info = { idx: '', isDup: false }) {
    commit(TYPES.EDITING_INFO, Object.assign({ enabled: true }, info));
  },
  async deleteWholesale({ dispatch }, idx) {
    try {
      this._vm.$confirm({
        title: '도매 삭제',
        content: '정말로 해당 도매를 삭제하시겠습니까?',
        okText: '네, 삭제합니다.',
        cancelText: '아니요',
        async onOk() {
          const { data } = await Axios.delete(
            `${Config.hostname}/v1/wholesale/${idx}`,
            {
              withCredentials: true
            }
          );

          if (AxiosMiddleware(data.opcode)) {
            switch (data.opcode) {
              case OPCODE.SUCCESS:
                dispatch('refreshWholesales');
                Config.alert.mixin({
                  type: 'success',
                  title: '성공적으로 삭제되었습니다.'
                });
                break;
            }
          }
        },
        onCancel() {
          Config.alert.mixin({
            type: 'info',
            title: '취소되었습니다.'
          });
        }
      });
    } catch (err) {
      Config.alert.mixin({
        type: 'error',
        title: '오류가 발생하였습니다.'
      });
    }
  }
};

export const getters = {};

export default { TYPES, state, mutations, getters, actions };
